import TYPES from './types';
import { get, put } from 'utils/api';

export const getAccount = () => dispatch => {
  dispatch({ type: TYPES.GET_ACCOUNT.START });

  return get('/user')
    .then(res => {
      dispatch({ type: TYPES.GET_ACCOUNT.SUCCESS, payload: res.data });

      return res.data;
    })
    .catch(error => dispatch({ type: TYPES.GET_ACCOUNT.ERROR, payload: error }));
};

export const updateAccount = params => dispatch => {
  dispatch({ type: TYPES.UPDATE_ACCOUNT.START });

  return put('/user', params)
    .then(res => {
      dispatch({ type: TYPES.UPDATE_ACCOUNT.SUCCESS, payload: res.data });

      return res.data;
    })
    .catch(error => dispatch({ type: TYPES.UPDATE_ACCOUNT.ERROR, payload: error }));
};
